import React, { useState, useEffect, useCallback } from 'react';
import { useSources } from 'hooks';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import { store } from 'store/createStore';

import AgencyWaitList from './AgencyWaitList';
import AgencyUsersTable from './AgencyUsersTable';
import HeaderAnalytics from '../../../Analytics/components/shared/HeaderAnalytics';

import API from 'utils/api';
import { classes } from 'utils';

import styles from './AgencyUsersAnalyticsHome.module.scss';

const AgencyUsersAnalyticsHome = () => {
  const [usersAnalyticsData, setUsersAnalyticsData] = useState({
    totalUsers: 0,
    totalWaitListUsers: 0,
    totalUsersFromWaitlist: 0,
  });

  const [selectedTab, setSelectedTab] = useState(0);
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [showDeletedUsers, setShowDeletedUsers] = useState(false);

  const sources = useSources();

  useEffect(() => {
    getUsersAnalytics();
  }, [showDeletedUsers]);

  const getUsersAnalytics = useCallback(() => {
    const { currentGroup } = store.getState().auth;

    let query = {
      group: currentGroup._id,
      hideDeletedUsers: !showDeletedUsers,
    };

    if (dateFrom) {
      query.dateFrom = dateFrom;
    }

    if (dateTo) {
      query.dateTo = dateTo;
    }

    API.getAgencyAnalytics(query, sources).then(({ data }) => {
      if (data) {
        const { totalUsers, totalWaitListUsers, totalUsersFromWaitlist } = data;

        setUsersAnalyticsData({ totalUsers, totalWaitListUsers, totalUsersFromWaitlist });
      }
    });
  });

  const renderSwitch = tab => {
    switch (tab) {
      case 0:
        return (
          <AgencyUsersTable
            dateFrom={dateFrom}
            dateTo={dateTo}
            showDeletedUsers={showDeletedUsers}
          />
        );
      case 1:
        return (
          <AgencyWaitList
            dateFrom={dateFrom}
            dateTo={dateTo}
            showDeletedUsers={showDeletedUsers}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <HeaderAnalytics
        title={'Users'}
        refreshData={getUsersAnalytics}
        dateFrom={dateFrom}
        setDateFrom={setDateFrom}
        dateTo={dateTo}
        setDateTo={setDateTo}
        element1_title={'Total users'}
        element1_value={usersAnalyticsData.totalUsers}
        element2_title={'Users from wait list'}
        element2_value={usersAnalyticsData.totalUsersFromWaitlist}
        element3_title={'Wait list'}
        element3_value={usersAnalyticsData.totalWaitListUsers}
      />
      <Paper className={classes(styles.paper, styles.filterPaper)} elevation={0}>
        <FormControlLabel
          style={{ float: 'right' }}
          control={
            <Checkbox
              checked={showDeletedUsers}
              onChange={() => {
                setShowDeletedUsers(!showDeletedUsers);
              }}
              color="primary"
            />
          }
          label="Show Deleted Users"
        />
      </Paper>
      <Paper className={styles.paper} elevation={0}>
        <Grid container>
          <Grid item xs={3}>
            <Tabs
              indicatorColor="primary"
              textColor="primary"
              value={selectedTab}
              onChange={(event, value) => setSelectedTab(value)}
              variant="fullWidth"
              scrollButtons="on"
            >
              <Tab label="USERS" />
              <Tab label="WAIT LIST" />
            </Tabs>
          </Grid>

          <Grid item xs={12}>
            {renderSwitch(selectedTab)}
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default AgencyUsersAnalyticsHome;
